/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import axios from 'axios';
import {apiCrypto} from '../endpoints';

const endpoint = apiCrypto;

export const getSigningKey = async (accessToken) => {
    const headers = {
        'Authorization': accessToken,
    };
    return axios.get(`${endpoint}api/v1/Secrets/MasterKeys/0`, {timeout: 20000, headers: headers})
    .then((response) => {
        return response;
    })
    .catch((error) => {
        return error;
    });
}
  